/** settings — EN source (55 keys). */
export const settings = {
  settings_account_section_title: "Account",
  settings_email_title: "Email",
  settings_email_subtitle: "Change your email address",
  settings_preferences_section_title: "Preferences",
  settings_language_title: "Language",
  settings_language_subtitle: "App display language",
  settings_push_notifications_title: "Push Notifications",
  settings_push_notifications_subtitle: "Receive notifications on your device",
  settings_push_notifications_test_title: "Test Push Notification",
  settings_push_notifications_test_description:
    "Send a test alert to confirm push notifications are working on this device.",
  settings_push_notifications_test_disabled_hint:
    "Enable push notifications above to send a test.",
  settings_push_notifications_test_button: "Send Test Notification",
  settings_push_notifications_test_button_loading: "Sending...",
  settings_dark_mode_title: "Dark Mode",
  settings_dark_mode_subtitle: "Use dark theme",
  settings_legal_support_section_title: "Legal & Support",
  settings_about_us_title: "About Us",
  settings_about_us_subtitle: "Learn more about Linqx",
  settings_about_version: "Version",
  settings_about_description:
    "Linqx helps you meet new people nearby and turn matches into real plans.",
  settings_about_visit_website: "Visit website",
  settings_privacy_policy_title: "Privacy Policy",
  settings_privacy_policy_subtitle: "How we protect your data",
  settings_terms_of_use_title: "Terms of Use",
  settings_terms_of_use_subtitle: "Read our terms and conditions",
  settings_app_version_title: "App Version",
  settings_logout_button: "Logout",
  settings_logout_confirmation_title: "Logout",
  settings_logout_confirmation_message: "Are you sure you want to logout?",
  settings_logout_confirmation_confirm: "Logout",
  settings_email_current_email_title: "Current Email",
  settings_email_new_email_title: "New Email Address",
  settings_email_address_label: "Email Address",
  settings_email_address_placeholder: "Enter new email address",
  settings_email_update_button: "Update Email",
  settings_email_updating_button: "Updating...",
  settings_email_info_message:
    "You'll need to verify your new email address before the change takes effect. We'll send a verification email to your new address.",
  settings_success_title: "Success",
  settings_success_email_updated: "Email updated successfully",
  settings_success_billing_updated: "Billing address updated successfully",
  settings_error_invalid_email: "Please enter a valid email address",
  settings_error_fill_required_fields: "Please fill in all required fields",
  settings_ok_button: "OK",
  notifications_success_title: "Success",
  notifications_success_settings_updated:
    "Notification settings updated successfully",
  notifications_success_token_registered:
    "Push notifications registered successfully",
  notifications_success_token_updated: "Push token updated successfully",
  notifications_success_token_deleted: "Push token deleted successfully",
  notifications_success_test_scheduled:
    "Test notification scheduled successfully",
  notifications_error_title: "Error",
  notifications_error_update_failed: "Failed to update notification settings",
  notifications_error_register_failed: "Failed to register push notifications",
  notifications_error_delete_failed: "Failed to delete push token",
  notifications_error_not_supported:
    "Push notifications are not supported on this device",
  notifications_error_permission_denied: "Notification permission denied",
  notifications_error_test_failed: "Failed to send test notification",
  notifications_confirm_delete_title: "Delete Push Token",
  notifications_confirm_delete_message:
    "Are you sure you want to delete this push token?",
  notifications_confirm_delete_cancel: "Cancel",
  notifications_confirm_delete_confirm: "Delete",
  settings_danger_section_title: "Danger zone",
  settings_deactivate_title: "Deactivate account",
  settings_deactivate_subtitle: "Hide your profile and sign out. Reversible.",
  settings_deactivate_confirm_title: "Deactivate account?",
  settings_deactivate_confirm_message:
    "Your profile will be hidden everywhere and you'll be signed out on all devices. You can reactivate by signing back in.",
  settings_deactivate_confirm_confirm: "Deactivate",
  settings_deactivate_error: "Couldn't deactivate. Try again.",
};
